module.exports = __webpack_public_path__ + "assets/img/HighPerformance.e4ba771e.jpg";